//--------------- IMPORTAÇÕES ---------------//
import dayjs from "dayjs";


//--------------- EXPORT DO UTILITÁRIO FORMATTER DATE DAY MONTH ---------------//
// Responsável por formatar uma data no formato DD/MM
export default function formatterDateDayMonth(dateString) {
   return dayjs(dateString).format("DD/MM");
}